import i18next, { type i18n as I18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import csCZ from './locales/cs-CZ.json';
import enUS from './locales/en-US.json';

export const SUPPORTED_LOCALES = ['cs-CZ', 'en-US'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

void i18next
  .use(LanguageDetector)
  .init({
    // The whole app drives i18next with SHORT language codes ('cs' | 'en') —
    // theme.ts `applyLocale`, the topbar UserMenu, the client AccountPage all
    // call changeLanguage('cs' | 'en'). The resources + supportedLngs MUST use
    // those same short codes, otherwise changeLanguage('en') is not "supported"
    // and silently falls back to Czech (the language-switch was a no-op).
    resources: {
      cs: { translation: csCZ },
      en: { translation: enUS },
    },
    fallbackLng: 'cs',
    supportedLngs: ['cs', 'en'],
    // Normalise any region-tagged detection (navigator 'en-US' / 'cs-CZ',
    // legacy stored values) down to the base 'en' / 'cs'.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'teivor.locale',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export const i18n: I18n = i18next;
export { csCZ, enUS };

/**
 * Inline bilingual helper for short cs/en literals that don't warrant a bundle
 * key (labels in formatter helpers, one-off JSX text). Returns English when the
 * active language is English, otherwise Czech. Use inside components that also
 * consume `useTranslation()` (or formatter functions called from them) so the
 * value re-renders when the language switches.
 */
export function L(cs: string, en: string): string {
  return (i18next.language || '').toLowerCase().startsWith('en') ? en : cs;
}
